import { render, staticRenderFns } from "./index.vue?vue&type=template&id=dcff950e&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=dcff950e&prod&lang=scss&scoped=true"
import style1 from "./index.vue?vue&type=style&index=1&id=dcff950e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dcff950e",
  null
  
)

export default component.exports